import { render, staticRenderFns } from "./ProjectsEdit.vue?vue&type=template&id=3b33d07e&scoped=true&"
import script from "./ProjectsEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsEdit.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProjectsEdit.vue?vue&type=style&index=1&id=3b33d07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33d07e",
  null
  
)

component.options.__file = "ProjectsEdit.vue"
export default component.exports